import React, { useState, useEffect } from "react";
import SideBar from "../Components/SideBar";
import ProductForm from "../Components/shop/sectionA";
import ProductDetailsForm from "../Components/shop/SectionB";
import  { GetShopData } from "../callApi/shop";
import Slider from "../Components/shop/Slider";
import DescImages from "../Components/shop/SectionD";
import Autocompletes from "../Components/shop/Autocomplete";
import { useDispatch } from "react-redux";
import { setLoading } from "../../Redux/action";
import apiRequest from "../../apiCall";
import toast from "react-hot-toast";
// import SNRForm from "../Components/shop/SectionC";

const Shop = () => {
  const [apiCalled, setApiCalled] = useState(false);
  const [first, setFirst] = useState(false);
  const dispatch = useDispatch();

  const change = () => {
    const inputField = document.getElementsByClassName("input-field");

    for (let i = 0; i < inputField.length; i++) {
      const element = inputField[i].childNodes;
      if (element[0].value !== "") {
        element[1].classList.add("active");
      }
    }
  };

 

  const handleChange = (inputValue) => {
    dispatch(setLoading(true));
    setFirst(false);
    sessionStorage.removeItem("shopApi");
    GetShopData(inputValue)
      .then((shopData) => {
        dispatch(setLoading(false));
        setApiCalled(true);
        setFirst(true);
        change();
      })
      .catch((error) => {
        console.error("Error calling shop API:", error);
      });
  };

  useEffect(() => {
    sessionStorage.removeItem("shopApi");
    // setApiCalled(true);
    // setFirst(true);
    // setApiCalled(false);
  }, []);

  const handleChildValueChange = (id) => {
    setFirst(false);
    handleChange(id);
  };

  const handleRefreshClick = () => {
    dispatch(setLoading(true));
    setFirst(false);
    apiRequest("POST", "refreshItem", null, true, true)
      .then((res) => {
        dispatch(setLoading(false));
        if (res?.message) {
          toast.success(res.message);
        }
      })
      .catch((error) => {
        console.error("Error calling home API:", error);
      });
  };

  return (
    <div className="admin-shop">
      <SideBar />
      <div className="admin-container">
        <br />
        <Autocompletes
          onChange={handleChange}
          refreshClick={handleRefreshClick}
        />
        {first ? (
          <>
            <Slider
              autoComplete={apiCalled}
              onValueChange={handleChildValueChange}
            />
            <ProductForm
              autoComplete={apiCalled}
              onValueChange={handleChildValueChange}
            />
            {/* <SNRForm
              autoComplete={apiCalled}
              onValueChange={handleChildValueChange}
            /> */}
            <ProductDetailsForm
              autoComplete={apiCalled}
              onValueChange={handleChildValueChange}
            />
            <DescImages
              autoComplete={apiCalled}
              onValueChange={handleChildValueChange}
            />
          </>
        ) : (
          <h6 style={{ margin: "1rem", fontWeight: "bold" }}>Select item</h6>
        )}
      </div>
    </div>
  );
};

export default Shop;
